/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class CartLink extends HTMLElement {
    constructor() {
        super();
        this.itemsCount = this.querySelector("items-count");
    }
    connectedCallback() {
        this.unsubscribe = Cart.subscribe((state => {
            this.itemsCount.textContent = state.cart.items.reduce((count, item) => item.properties?._dn13_gift_role === 'fee' ? count : count + item.quantity, 0).toString();
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
    }
}

customElements.define("cart-link", CartLink);
//# sourceMappingURL=cart-link.js.map
